import { useTranslation } from 'react-i18next';
import { homeDisciplines } from '@/mocks/home';

export default function Disciplines() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'kk';

  const isEn = lang.startsWith('en');
  const isRu = lang.startsWith('ru');

  return (
    <section id="disciplines" className="relative bg-background-950 overflow-hidden">
      <div className="absolute inset-0 tactical-grid opacity-15 pointer-events-none" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 lg:py-32">
        {/* Section header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="section-label mb-4">
            {t('disciplines.title', isEn ? 'Sport Disciplines' : isRu ? 'Направления спорта' : 'Спорт бағыттары')}
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 uppercase tracking-tight">
            {isEn ? 'Core Operations' : isRu ? 'Виды деятельности' : 'Қызмет түрлері'}
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-foreground-500 text-sm leading-relaxed">
            {isEn
              ? 'Comprehensive professional training in military-applied sports disciplines'
              : isRu
              ? 'Комплексная подготовка по военно-прикладным видам спорта на профессиональном уровне'
              : 'Кәсіби деңгейдегі әскери-қолданбалы спорт түрлері бойынша кешенді дайындық'}
          </p>
        </div>

        {/* Disciplines grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {homeDisciplines.map((discipline, index) => {
            const title = isEn ? discipline.titleEn : isRu ? discipline.titleRu : discipline.titleKk;
            const description = isEn ? discipline.descriptionEn : isRu ? discipline.descriptionRu : discipline.descriptionKk;
            return (
              <div
                key={discipline.id}
                className="group relative bg-background-900/50 border border-background-800/50 overflow-hidden hover:border-accent-500/30 transition-all duration-500"
              >
                {/* Image */}
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={discipline.image}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-900 via-background-900/40 to-transparent" />

                  {/* Index number */}
                  <div className="absolute top-4 left-4 font-mono text-xs text-accent-500/60">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                </div>

                {/* Content */}
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center border border-accent-500/20">
                      <i className={`${discipline.icon} text-accent-500 text-sm`} />
                    </div>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 uppercase tracking-wide">
                      {title}
                    </h3>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {description}
                  </p>
                </div>

                {/* Hover accent */}
                <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-accent-500 group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-accent-500/20 to-transparent" />
    </section>
  );
}